import router from '@/router'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import common from '@/utils/common'
import store from '@/store'

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    if (getToken()) {
      store.dispatch('signin/GetInfo')
      next()
    } else {
      Message.error(common.message.signinRequest)
      next({ path: '/signin' })
    }
  }
  next()
})
